const navigateToAqila1 = (path = '') => {
  window.location.href = `/#!/${path}`;
};

export default navigateToAqila1;
